import React, { useState, useEffect } from "react";
import { calcBillTotals } from "../../../core/utils/salesTotals";
import {
  lineDiscountInput,
  writeLineDiscount,
  discPctEvents,
  discAmtRules,
  savedDiscountMode,
} from "../../../core/utils/lineDiscount";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Plus,
  ChevronRight,
  Trash2,
  RotateCcw,
  Printer,
  Check,
} from "feather-icons-react/build/IconComponents";
import {
  getSupplierList,
  getTaxList,
  getDiscountList,
  getUnitList,
  getDiscountbyguid,
  getWareHouseList,
} from "../../../services/MasterApiServices";
import "../../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermMoreToggle,
  TermColumns,
  TermStatusBar,
  ENTRY_HINTS,
} from "../terminal/TerminalChrome";
import {
  useItemEntry,
  TermScanBar,
  TermLineFacts,
} from "../terminal/ItemEntry";
import { useTender, TermTender, TermRoundOff } from "../terminal/Tender";
import { getProductList } from "../../../services/MasterApiServices";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { PurchaseClass } from "../../../core/json/Purchase";
import { PurchaseDetailClass } from "../../../core/json/PurchaseDetail";
import toast from "react-hot-toast";
import {
  addEditPurchase,
  getPurchaseByTransType,
} from "../../../services/PurchaseApiService";
import SupplierModal from "../../master/modal/SupplierModal";
import { ProductClass } from "../../../core/json/Product";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { DiscountClass } from "../../../core/json/Discount";
import { TaxClass } from "../../../core/json/TaxClass";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSupplier,
  fetchSettings,
} from "../../../redux/userSetting";
import { FinancialYear } from "../../../core/json/FinancialYear";
import QRCode from "qrcode";
import { Buffer } from "buffer";
import { getPrintSettingsByBranch } from "../../../services/AdminApiServices";

const PurchaseInvoiceModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date: dayjs().format("YYYY-MM-DD"),
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invoiceDate: dayjs().format("YYYY-MM-DD"),
      duedate: dayjs().format("YYYY-MM-DD"),
      addition: 0,
      subtraction: 0,
      round: 0,
      paymentType: 0,
      referencetype: 0,
    },
    mode: "onBlur",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
    dispatch(fetchSupplier());
  }, []);

  const [taxData, setTaxData] = useState([]);
  const [unitData, setunitData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
const [printAfterSubmit, setPrintAfterSubmit] = useState(false); // New state variable
  const [products, setProducts] = useState([]);
  const [discountList, setdiscountList] = useState([]);
const [warehouses, setWarehouses] = useState([]);
const [printSettings, setPrintSettings] = useState([]); 
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);
  const { branchsettings } = useSelector((state) => state.settings);
  const { companyInfolist } = useSelector((state) => state.companyInfo);

  const { productList, unitList, taxList, supplierList, settingList } =
    useSelector((state) => state.usersetting);

  // Get branch from redux
  const { branch } = useSelector((state) => state.branchlist);

  const paymentType = [
    { value: 0, label: "Cash" },
    { value: 1, label: "Card" },
    { value: 2, label: "Bank" },
    { value: 3, label: "Credit" },
    // "UPI" renamed Online; the stored value (4) is unchanged
    { value: 4, label: "Online" },
  ];
  const referencetype = [
    { value: 0, label: "Direct" },
    { value: 1, label: "Order" },
    { value: 2, label: "Goods Receipt" },
  ];

 useEffect(() => {
   const fetchPrintSettings = async () => {
     try {
       const response = await getPrintSettingsByBranch(branch?.guid);
       setPrintSettings(response);
     } catch (error) {
       console.error("Failed to fetch print settings", error);
     }
   };
 
   if (branch?.guid) {
     fetchPrintSettings();
   }
 }, [branch]);

useEffect(() => {
  const fetchWarehouses = async () => {
    try {
      const response = await getWareHouseList();

      if (Array.isArray(response)) {
        // Filter warehouses by current branch
        const filtered = response.filter(
          (wh) => wh.branchID === branch?.guid
        );
        setWarehouses(filtered);
      } else {
        setWarehouses([]);
      }
    } catch (err) {
      console.error("Failed to fetch warehouses:", err);
    }
  };
  if (branch?.guid) {
    fetchWarehouses();
  }
}, [branch]);
          
        const formattedWarehouses = Array.isArray(warehouses)
          ? warehouses.map((warehouse) => ({
              label: warehouse.name || "Unnamed Warehouse",
              value: warehouse,
            }))
          : [];
        
        // Helper function to get selected warehouse option
        const getSelectedWarehouseOption = (warehouse) => {
          if (!warehouse) return null;
          return (
            formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid) || {
              label: warehouse.name || "Select Warehouse",
              value: warehouse,
            }
          );
        };

    // Helper to get default warehouse from branch settings
const getDefaultWarehouse = () => {
  if (!branchsettings?.defaultWareHouseID || !warehouses?.length) return null;
  const wh = warehouses.find((w) => w.guid === branchsettings.defaultWareHouseID);
  return wh ? getSelectedWarehouseOption(wh) : null;
};

  // const purchaseTransType = [
  //   { value: 0, label: "Order" },
  //   { value: 1, label: "Goods Receipt" },
  //   { value: 2, label: "Invoice" },
  //   { value: 3, label: "Return" },
  // ];

  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    // Check for null, undefined, or empty string and use the default value
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    // Convert to number
    const num = Number(value);

    // Return the number or the default value if num is NaN
    return isNaN(num) ? defaultValue : num;
  };
  const rowUseForm = getValues("row") || [];

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;

  // VAT the ZATCA way, the same on every screen, print and e-invoice
  // (core/utils/salesTotals.js): the bill discount (subtraction) and the
  // addition change the taxable amount, and VAT is worked out on what is left
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));
  const billCalc = calcBillTotals(
    fields.map((field, index) => {
      const taxGUID = watch(`items[${index}].taxPercentage`, 0);
      return {
        quantity: watch(`items[${index}].quantity`, 0),
        price: watch(`items[${index}].price`, 0),
        ...lineDiscountInput(watch, index),
        taxPercent: taxData.find((t)=>t.guid==taxGUID)?.value || 0,
      };
    }),
    {
      billDiscount: safeNumber(subtraction),
      addition: safeNumber(addition),
      roundOff: safeNumber(round),
      decimals: Number(decimalpoints) >= 0 ? Number(decimalpoints) : 2,
    }
  );
  billCalc.lines.forEach((t, index) => {
    setValue(`items[${index}].gross`, t.gross.toFixed(decimalpoints));
    writeLineDiscount(getValues, setValue, index, t, decimalpoints);
    setValue(`items[${index}].taxAmount`, t.tax.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, t.net.toFixed(decimalpoints));
  });
  totalGross = billCalc.gross;
  totalDiscount = billCalc.discountTotal;
  totalTax = billCalc.tax;
  totalNet = billCalc.net;
  //end-------------
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one product entry is required");
    }
  }

  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleTaxList = async () => {
    try {
      const formattedTax = taxList?.map((tax) => ({
        label: tax.percentage,
        value: tax.percentage,
        guid: tax.guid,
      }));
      setTaxData(formattedTax);
    } catch (error) {
      console.error(
        "Error fetching tax",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();
      // Disc % is typed on the line; the master is only used on save to keep
      // the matching discount's guid/name
      setdiscountList(response);
    } catch (error) {
      console.error(
        "Error fetching discount",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      // the line shows the barcode (item code when there is none), as the
      // Sales Invoice does
      setValue(
        `items[${index}].code`,
        `${productData?.barcode || productData?.code || ""}`
      );
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].taxPercentage`,productData?.taxID);
      setValue(`items[${index}].price`, productData?.cost || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.filter(
        (product) => product.guid === guid
      );
      return filteredData[0];
    } catch (error) {
      console.error("Error fetching products", error);
    }
  }

  const handleSupplierList = async () => {
    try {
      const formattedSuppliers = supplierList?.map((supplier) => ({
        label: supplier.name,
        value: supplier.guid,
      }));
      setSupplierData(formattedSuppliers);
    } catch (error) {
      console.error("Error fetching suppliers", error);
    }
  };

  // Fetch purchase invoices data
  const handleEntryNo = async () => {
    try {
      const response = await getPurchaseByTransType(branch, 2);
      const purchaseData = response.data;
      // Find the maximum number from the existing entries
      const maxEntryNumber =
        purchaseData?.length > 0
          ? purchaseData
              ?.map((data) => parseInt(data.entrynumber.replace(/\D/g, ""))) // Extract and parse numbers
              .reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;
      let counter = maxEntryNumber + 1;
      setValue(`entrynumber`, `PI${counter}`);
      counter++;
    } catch (error) {
      console.error("Failed to fetch purchase invoices", error);
    }
  };
  // useEffect(() => {
  //   if (mode === "add") {
  //     handleEntryNo();
  //     if (!isRowAdded && fields?.length === 0) {
  //       handleAddRow();
  //       setIsRowAdded(true);
  //     }
  //   }

  //   handleProductsList();

  //   handleTaxList();
  //   handleUnitList();
  //   handleDiscountList();
  // }, []);
  
  useEffect(() => {
  const fetchData = async () => {
    if (mode === "add") {
      handleEntryNo();

      // Add first row if none exists
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }

       // Set default warehouse if available
      const defaultWarehouse = getDefaultWarehouse();
      if (defaultWarehouse) {
        setValue("wareHouse", defaultWarehouse.value);
      }
    }

    // Fetch all lists
    handleProductsList();
    handleTaxList();
    handleUnitList();
    handleDiscountList();
  };

  fetchData();
}, [branchsettings, warehouses]);


  function resetmodal() {
    if (mode === "edit" && data) {
      // Populate form with data for editing
      //purchase fields population
      setValue("entrynumber", data.entrynumber);
      setValue("remarks", data.remarks);
      setValue("refNo", data.refNo);
      setValue("shipmentNo", data.shipmentNo);
      setValue("shipmentTerms", data.shipmentTerms);
      setValue("invoiceNo", data.invoiceNo);
      setValue("addition", data.addition);
      setValue("subtraction", data.discount);
      setValue("round", data.roundOff);
      setValue("advancePaid", data.advancePaid || 0);
      setValue("grossTotal", data.grossTotal);
      setValue("discountTotal", data.discountTotal);
      setValue("taxTotal", data.taxTotal);
      setValue("netTotal", data.netTotal);
      // selectboxes
      setValue("paymentType", data.purchasePaymentType);

      setValue("referencetype", data.referencetype || 0);
      setValue("supplier", data.supplier.guid);
      //dates

      setValue("date", dayjs(data.date));
      setValue("invoiceDate", dayjs(data.invoiceDate));
      setValue("duedate", dayjs(data.duedate) || dayjs().format("YYYY-MM-DD"));
if (data.wareHouse?.guid) {
  const selectedWarehouse = getSelectedWarehouseOption(data.wareHouse);
      setValue("wareHouse", selectedWarehouse.value || data.wareHouse);
    }
      setValue(
        "items",
        data?.purchaseDetails?.map((detail, i) => ({
          product: detail?.product?.guid,
          code: detail?.product?.code,
          // hsnCode: detail?.product?.hsnCode || 0,
          batch: detail.batch,
          expiry: dayjs(detail.expiry),
          unit: detail.unit?.guid,
          quantity: detail.quantity,
          price: detail.price,
          mrp: detail.mrp,
          foc: detail.foc,
          discountPercentage: detail.discount?.percentage,
          discountAmount: detail.discountAmount,
          discountMode: savedDiscountMode(detail.discountAmount),
          taxPercentage: detail.tax?.guid,
          gross: detail.gross,
          taxAmount: detail.taxAmount,
          netTotal: detail.netTotal,
        }))
      );
    }
  }

  useEffect(() => {
    resetmodal();
  }, [data, setValue]);

  useEffect(() => {
    handleSupplierList();
  }, [supplierList]);

  const handleProductsList = async () => {
    try {
      const formattedProducts = productList?.map((product) => ({
        label: product.name,
        value: product.guid,
      }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleAddRow = () => {
    append({
      batch: "0",
      code: "0",
      discountAmount: "0.0",
      discountPercentage: "0.0",
      expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      // hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: "0",
      unit: "",
      product: null,
    });
  };

  const handleFormSubmit = async (formdata) => {
    const objPurchase = new PurchaseClass();
    if (mode === "edit") {
      objPurchase.guid = data.guid;
      objPurchase.id = data.id;
    }
    const objfinance = new FinancialYear();
    objfinance.id = branchsettings?.defaultFinancialYearID;

    objPurchase.branch = branch;
    objPurchase.date = formdata.date
      ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");
    objPurchase.purchasePaymentType = formdata.paymentType;
    objPurchase.purchaseTransType = 2;

    // Get supplier data asynchronously
objPurchase.wareHouse = formdata.wareHouse;     
    objPurchase.supplier = supplierList?.find(
      (e) => e.guid == formdata.supplier
    );
    objPurchase.updatedUser = `{${userId?.id}}`;
    objPurchase.invoiceDate = formdata.invoiceDate
      ? dayjs(formdata.invoiceDate).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");
    objPurchase.invoiceNo = formdata.invoiceNo || "0";
    objPurchase.refNo = formdata.refNo || "0";
    objPurchase.shipmentNo = formdata.shipmentNo || "0";
    objPurchase.shipmentTerms = formdata.shipmentTerms || "";
    objPurchase.remarks = formdata.remarks || "";
    objPurchase.addition = formdata.addition || 0.0;
    objPurchase.discount = formdata.subtraction || 0.0;
    objPurchase.roundOff = formdata.round || 0.0;
    objPurchase.advancePaid = Number(formdata.advancePaid) || 0;
    // which card machine took an online payment - no column for it yet, see
    // docs/BACKEND-COMPLETE.md (Part 5)
    objPurchase.paymentCard = formdata.paymentCard || null;
    objPurchase.grossTotal = totalGross || 0;
    objPurchase.discountTotal = totalDiscount || 0.0;
    objPurchase.taxTotal = totalTax || 0.0;
    objPurchase.netTotal = totalNet || 0.0;
    objPurchase.referencetype = formdata.referencetype || 0;
    objPurchase.entrynumber = formdata.entrynumber || 0;
    objPurchase.duedate = formdata.duedate
      ? dayjs(formdata.duedate).format("YYYY-MM-DDTHH:mm:ss")
      : dayjs().format("YYYY-MM-DD");

    objPurchase.financialYear = objfinance;
    objPurchase.company = companyInfolist[0];

   
    const detailObj = formdata?.items?.map((e) => {
    
      const defaultDiscountobj = new DiscountClass();
      const defaultTaxobj = new TaxClass();

      let product;
      const productValue = e.product || e.product.value;
     
      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList?.find((item) => item.guid == e.unit);
      const taxPercentage=taxData?.find((item)=>item.guid==e.taxPercentage)?.value
      // Disc % is typed now (or follows a typed Disc Amt); the API keeps only
      // the percentage and the line amount, so a percentage that is not in the
      // discount master (e.g. 7.5) is still sent
      const discountPct = Number(e.discountPercentage) || 0;
      const masterDiscount = discountList?.find(
        (item) => Number(item.percentage) === discountPct
      );
      const discount = {
        ...(masterDiscount || defaultDiscountobj),
        percentage: discountPct,
      };
      // the line keeps the tax guid; the percentage is derived from it (TR-8)
      const tax =
        taxList?.find((item) => item.guid == e.taxPercentage) || defaultTaxobj;

      const expiry = e.expiry
        ? dayjs(e.expiry).format("YYYY-MM-DDTHH:mm:ss")
        : dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const detailObj = {
        product,
        unit,
        batch: e.batch,
        expiry,
        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp,
        foc: e.foc,
        taxAmount: e.taxAmount,
        grossAmount: e.gross,
        netAmount: e.netTotal,
        discountAmount: e.discountAmount,
        discount,
        tax,
        taxPercentage
      };

    

      return detailObj;
    });
    objPurchase.purchaseDetails = detailObj;
    try {
    
      const response = await addEditPurchase(objPurchase);
      // success is a literal true (G-2) - a 200 "false" is a failure
      if (response?.data !== true) {
        toast.error(response?.data?.Message || "Not saved - please try again");
      } else {
        toast.success("Success");
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal
                             if (printAfterSubmit) {
           printA4Function();      // 👈 only called if user clicked "Save & Print"
           setPrintAfterSubmit(false); // reset flag
         }
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message);
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
        // const generateFatooraQR = (sellerName, vatNumber, invoiceDate, invoiceTotal, vatTotal) => {
        //   const encodeTLV = (tag, value) => {
        //     const encodedTag = Buffer.from([tag]).toString("hex");
        //     const encodedLength = Buffer.from([value.length]).toString("hex");
        //     const encodedValue = Buffer.from(value, "utf-8").toString("hex");
        //     return encodedTag + encodedLength + encodedValue;
        //   };
        
        //   const qrDataHex =
        //     encodeTLV(1, sellerName) +
        //     encodeTLV(2, vatNumber) +
        //     encodeTLV(3, invoiceDate) +
        //     encodeTLV(4, invoiceTotal) +
        //     encodeTLV(5, vatTotal);
        
        //   const qrDataBase64 = Buffer.from(qrDataHex, "hex").toString("base64");
        //   return qrDataBase64;
        // };
      
        const printA4Function = async() => {
          const form = document.getElementById("invoice-content");
        
          if (!form) {
            console.error("Element with ID 'invoice-content' not found.");
            return;
          }
      
          // const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info
      
          // // Extract company details
          // const companyName = company.name || "Company Name";
          // const companyAddress1 = company.address1 || "";
          // const companyAddress2 = company.address2 || "";
          // const companyAddress3 = company.address3 || "";
          // const companyPhone = company.phone || "";
          // const companyVAT = company.tin || "";
          // Extract values from form inputs
          
      const company = printSettings?.[0] ?? {};

    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
          
               const supplierGuid = watch("supplier");
         const supplierObj = supplierList.find(sup => sup.guid === supplierGuid) || {};
         const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
         const supplierAddress1 = supplierObj.address1 || "";
         const supplierMobile = supplierObj.mobile || "";
         const supplierVAT = supplierObj.gstNo || "";   
          
          const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
      
      const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
      const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
      const invDateValue = watch("invdate") || new Date().toISOString();
        const invoiceDate = new Date(invDateValue).toISOString();
          const customerName = form.querySelector("input[name='customerName']")?.value || "";
          const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
          const fields = watch("items") || [];
      // const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
      // const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
      const  netTotal = fields.reduce((sum, item) => sum + (parseFloat(item.netTotal) || 0), 0);
      // const addition = parseFloat(watch("addition")) || 0;
      // const round = parseFloat(watch("round")) || 0;
      // Store the totals in React Hook Form
      // setValue("discount", discount.toFixed(2));
      // setValue("taxTotal", taxTotal.toFixed(2));
      // setValue("netTotal", netTotal.toFixed(2));
      
      const grossTotalPrint = Number(totalGross) || 0;
      const discountPrint = Number(totalDiscount) || 0;
      const taxTotalPrint = Number(totalTax) || 0;
      const netTotalPrint = Number(totalNet) || 0;
      
      const additionPrint = Number(watch("addition")) || 0;
      const roundPrint = Number(watch("round")) || 0;
      
      
      console.log({ totalDiscount, totalTax, totalNet });
      
        
          // Extract table data
        
      
        // const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(row => {
        //   // Query the react-select component for the current row
        //   const selectContainer1 = row?.querySelector('.css-b62m3t-container');
        //   const selectContainer = selectContainer1?.querySelector('.react-select__control');
        //   const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
        //   const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
        
        //   // Extract the text or value of the selected option
        //   const selectedValue = selectedValueDiv?.textContent || "N/A";
        
        //   // Extract other values from the row (quantity, rate, total)
        //   return {
        //     description: selectedValue,
        //     qty: parseInt(row.querySelector("td:nth-child(6) input")?.value?.trim()) || 0,
        //     rate: parseFloat(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0.00,
        //     total: parseFloat(row.querySelector("td:nth-child(10) input")?.value?.trim()) || 0.00
        //   };
        // });
      const paymentTypeLabel =
        paymentType?.find(p => p.value === watch("paymentType"))?.label || "";
      
      
        //     const tableRows = Array.from(form.querySelectorAll("tbody tr.si-line")).map((row, index) => ({
        //   description: row.querySelector('td[data-label="Description"]')?.innerText || "",
        //   code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
        //   hsnCode: row.querySelector('td[data-label="HSN Code"] input')?.value || "",
        //   qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
        //   unit: row.querySelector('td[data-label="Unit"] input')?.value || "",
        //   rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
        //   discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
        //   tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
        //   total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
        //   netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
        // }));
        const tableRows = Array.from(form.querySelectorAll("tbody tr.si-line")).map((row) => {
        const unitText =
          row
            .querySelector('td[data-label="Unit"] .react-select__single-value')
            ?.textContent || "";
      
        return {
          description: row.querySelector('td[data-label="Description"]')?.innerText || "",
          code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
          qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
          unit: unitText,
          rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
          tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
            discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
          total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
          netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
        };
      });
      
        console.log(tableRows,"lkkk");
      
        // const qrData = `Company: ${companyName}\nDate: ${date}\nDelivery Date: ${deliveryDate}\nNet Total: ${netTotal.toFixed(2)}`;
          
        //   const qrCodeUrl = await QRCode.toDataURL(qrData);
      
       // const fatooraQRData = generateFatooraQR(companyName, companyVAT, invoiceDate, netTotalPrint.toFixed(2), taxTotalPrint.toFixed(2));
       // const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);
      
      
      const amountInWords = (num) => {
        if (!num || isNaN(num)) return "";
      
        const a = [
          "", "One", "Two", "Three", "Four", "Five",
          "Six", "Seven", "Eight", "Nine", "Ten",
          "Eleven", "Twelve", "Thirteen", "Fourteen",
          "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
      
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
      
        const numberToWords = (n) => {
          if (n < 20) return a[n];
          if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
          if (n < 1000)
            return (
              a[Math.floor(n / 100)] +
              " Hundred" +
              (n % 100 ? " " + numberToWords(n % 100) : "")
            );
          if (n < 1000000)
            return (
              numberToWords(Math.floor(n / 1000)) +
              " Thousand" +
              (n % 1000 ? " " + numberToWords(n % 1000) : "")
            );
          return "";
        };
      
        const integerPart = Math.floor(num);
        const decimalPart = Math.round((num - integerPart) * 100);
      
        const riyalPart = numberToWords(integerPart);
        const halalahPart = decimalPart ? numberToWords(decimalPart) : "";
      
        return `${riyalPart} Riyal${
          halalahPart ? " and " + halalahPart + " Halalah" : ""
        } Only`;
      };
      
      
      const printableContent = `
      <!DOCTYPE html>
      <html lang="ar">
      <head>
      <meta charset="UTF-8" />
      <title>Tax Invoice</title>
      
      <style>
      @page { size: A4; margin: 10mm; }
      
      body {
        font-family: Arial, sans-serif;
        font-size: 11px;
        color: #000;
      }
      
      .center { text-align: center; }
      .left { text-align: left; direction: ltr; }
      .right { text-align: right; direction: rtl; }
      .bold { font-weight: bold; }
      
      .header p { margin: 2px 0; }
      .header h2 { margin: 4px 0; } 
      
      .invoice-title {
        margin: 16px 16px;
        font-weight: bold;
        
      }
      
      /* DEFAULT TABLE */
      table {
        width: 100%;
        border-collapse: collapse;
      }
      
      /* HEADER & INFO TABLES */
      th {
        border: 1px solid #000;
        padding: 4px;
      }
      
      .header table td,
      table:not(.items) td {
        border: 1px solid #000;
        padding: 4px;
      }
      
      /* ITEMS TABLE OUTER BORDER */
      .items {
        border: 1px solid #000;
      }
      
      /* ITEM HEADER GRID */
      .items thead th {
        border: 1px solid #000;
      }
      
      /* ITEM BODY — NO VERTICAL LINES */
      /* ITEM BODY — ONLY VERTICAL LINES (REFERENCE STYLE) */
      .items tbody td {
        border-top: none;
        border-bottom: none;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
        padding: 6px 4px;
        text-align: center;
        height: 26px;
      }
      
      
      
      
      /* BOTTOM BORDER OF ITEMS */
      .items tbody tr:last-child td {
        border-bottom: 1px solid #000;
      }
      
      
      .small { font-size: 10px; }
      
      .no-border tr td { border: none; }
      
      .items th { font-size: 10px; }
      .items td { font-size: 11px; text-align: center; }
      
      /* FORCE ITEM TABLE HEIGHT */
      .items tbody {
        height: 470px;
      }
      .totals{
      border: 1px solid #000;
      }
      .totals tr td {
         border-top: none;
        border-bottom: none;
        border-left: none;
        border-right: none;
        padding: 6px 4px;
      }
      .totals td:last-child {
        border-left: 1px solid #000;
      }
      
      .footer-fixed {
        margin-top: 18px;
        font-size: 10px;
      }
      
      .footer-fixed tr td {
        border: none;
      }
      </style>
      </head>
      
      <body>
      
      <!-- HEADER (UNCHANGED AS REQUESTED) -->
      <div class="header center">
  <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
      
 
      
        <div class="invoice-title">TAX INVOICE &nbsp;&nbsp; الفاتورة الضريبية</div>
      </div>
      
      <!-- INVOICE INFO -->
      <table>
      <tr>
        <td class="left small"><b>Purchase Invoice No :</b> ${entryNumber}</td>
        <td class="center small"><b>Date :</b> ${date}</td>
        <td class="right small"><b>Type :</b> ${paymentTypeLabel}</td>
      </tr>
      </table>
      
      <!-- CUSTOMER DETAILS -->
      <table style="margin-top:4px;">
      <tr>
        <th colspan="4" class="center small">SUPPLIER DETAILS &nbsp;&nbsp; تفاصيل العميل</th>
      </tr>
      <tr>
        <td class="left small"><b>NAME</b></td>
        <td class="left">${supplierName}</td>
        <td></td>
        <td class="right small"><b>اسم</b></td>
      
      </tr>
      <tr>
        <td class="left small"><b>CONTACT</b></td>
        <td class="left">${supplierMobile}</td>
        <td>${supplierMobile}</td>
        <td class="right small"><b>رقم الاتصال</b></td> 
      </tr>
      <tr>
        <td class="left small"><b>VAT NO</b></td>
        <td class="left">${supplierVAT}</td>
          <td>${supplierVAT}</td>
        <td class="right small"><b>الرقم الضريبي</b></td>
      
      </tr>
      <tr>
        <td class="left small"><b>CR NO</b></td>
        <td class="left"></td>
          <td></td>
        <td class="right small"><b>رقم السجل التجاري</b></td>
      
      </tr>
      <tr>
        <td class="left small"><b>ADDRESS</b></td>
        <td colspan="3">${supplierAddress1}</td>
      </tr>
      </table>
      
      <!-- ITEMS -->
      <table class="items" style="margin-top:4px;">
      <thead>
      <tr>
        <th>Sl.No<br/>رقم</th>
        <th>Barcode<br/>الباركود</th>
        <th>Description<br/>الوصف</th>
        <th>Qty<br/>كمية</th>
        <th>Unit<br/>وحدة</th>
        <th>Unit Price<br/>سعر الوحدة</th>
        <th>Taxable Amt<br/>المبلغ الخاضع</th>
        <th>Tax Amt<br/>مبلغ الضريبة</th>
        <th>Total<br/>المجموع</th>
      </tr>
      </thead>
      
      <tbody>
      ${
      (() => {
        const minRows = 9;
        const emptyRows = minRows - tableRows.length;
      
        return `
        ${tableRows.map((row, i) => `
        <tr>
          <td>${i + 1}</td>
          <td>${row.code}</td>
          <td class="left">${row.description}</td>
          <td>${row.qty}</td>
          <td>${row.unit}</td>
          <td>${row.rate.toFixed(2)}</td>
          <td>${row.total.toFixed(2)}</td>
          <td>${row.tax.toFixed(2)}</td>
          <td>${row.netTotal.toFixed(2)}</td>
        </tr>
        `).join("")}
      
        ${Array.from({ length: Math.max(0, emptyRows) }).map(() => `
        <tr>
          <td>&nbsp;</td><td></td><td></td><td></td>
          <td></td><td></td><td></td><td></td><td></td>
        </tr>
        `).join("")}
        `;
      })()
      }
      </tbody>
      </table>
      
      <!-- TOTALS -->
      <table class="totals" style="margin-top:6px;">
      <tr>
        <td class="left small">
      VAT (${((taxTotalPrint / (netTotalPrint - taxTotalPrint)) * 100).toFixed(2)}%)
        </td>
        <td></td>
        <td class="right bold" style="padding-right:16px;">Total</td><td>المجموع</td> 
        <td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td>
      </tr>
      <tr>
        <td colspan="2"></td>
        <td class="right bold" style="padding-right:16px;">VAT</td><td>ضريبة القيمة المضافة</td> 
        <td class="right">${taxTotalPrint.toFixed(2)}</td>
      </tr>
      <tr>
        <td colspan="2"></td>
        <td class="right bold" style="padding-right:16px;">Discount </td><td> تخفيض</td> 
        <td class="right">${discountPrint.toFixed(2)}</td>
      </tr>
      <tr>
        <td colspan="2"></td>
        <td class="right bold" style="padding-right:16px;">Sub Total </td><td>المجموع الفرعي</td> 
        <td class="right">${netTotal.toFixed(2)}</td>
      </tr>
      
      <tr>
        <td colspan="2"></td>
        <td class="right bold" style="padding-right:16px;">Addition</td><td>إضافة</td> 
        <td class="right">${additionPrint.toFixed(2)}</td>
      </tr>
      <tr>
        <td colspan="2"></td>
        <td class="right bold" style="padding-right:16px;">Round off</td><td >تقريب</td> 
        <td class="right">${roundPrint.toFixed(2)}</td>
      </tr>
      <tr>
        <td class="left bold">
           ${amountInWords(netTotalPrint)}
        </td>
        <td></td>
        <td class="right bold" style="padding-right:16px;">Net Total</td><td class="bold">صافي المجموع</td> 
        <td class="right bold">${netTotalPrint.toFixed(2)}</td>
      </tr>
      </table>
      
      <!-- QR & FOOTER -->
      <table class="footer-fixed">
      <tr>
        <td class="right bold" style="font-size:12px; padding-right:20px;">
          For ${companyName}<br/>
        </td>
      </tr>
      </table> 
      
      </body>
      </html>
      `;
      
      
      
          // Create an iframe for better printing
          const iframe = document.createElement("iframe");
          iframe.style.position = "absolute";
          iframe.style.width = "0px";
          iframe.style.height = "0px";
          iframe.style.border = "none";
          document.body.appendChild(iframe);
        
          const doc = iframe.contentWindow.document;
          doc.open();
          doc.write(printableContent);
          doc.close();
        
          iframe.contentWindow.focus();
          setTimeout(() => {
            iframe.contentWindow.print();
            iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
          }, 500);
        };

  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const menuPortalTarget =
    menuHost || (typeof document !== "undefined" ? document.body : null);
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen, More row, visible columns
  // (same defaults as the Sales Invoice: Batch / Expiry / MRP / FOC live in the
  // line's detail row until their column is switched on)
  const chrome = useTerminalChrome("purchaseInvoice", {
    code: false,
    batch: false,
    expiry: false,
    mrp: false,
    foc: false,
    gross: false,
    tax: true,
  });
  const colOn = (key) => chrome.cols[key] !== false;

  // scan bar, entry flow, barcode lookup and keyboard - shared with every
  // sales and purchase screen; lines still load through this screen's own
  // handleAddRow / handleEachProductfetch
  const entry = useItemEntry({
    screenKey: "purchaseInvoice",
    productList,
    unitOptions: unitData,
    getValues,
    setValue,
    handleAddRow,
    handleEachProductfetch,
    rateOf: (p) => p?.cost,
    removeLine: handleRemove,
    blocked: modalOpen,
  });
  const fmtN = (v) => safeNumber(v).toFixed(decimalpoints);

  // line details (batch / expiry / MRP / FOC when their column is off, and
  // the product facts), keyed by field id
  const [openRows, setOpenRows] = useState({});
  const toggleRow = (id) =>
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));

  // purchase VAT always shows in the grid (the totals always show it too);
  // disableTaxInSale is a sales setting
  const taxOn = true;
  const selectedSupplier = supplierList?.find(
    (s) => s.guid === watch("supplier")
  );
  const paymentLabel = paymentType.find(
    (p) => p.value === watch("paymentType")
  )?.label;
  const liveRows = getValues("items") || [];
  const realRows = liveRows.filter((r) => r?.product);
  const lineCount = realRows.length;
  const qtyTotal = realRows.reduce((s, r) => s + safeNumber(r.quantity), 0);
  const retailTotal = realRows.reduce(
    (s, r) =>
      s +
      safeNumber(r.quantity) *
        safeNumber(entry.productByGuid(r.product)?.retailRate),
    0
  );
  const billDiscount = safeNumber(subtraction);
  const lineDiscount = totalDiscount - billDiscount;
  const taxableTotal = totalGross - lineDiscount - billDiscount + safeNumber(addition); // the amount VAT is charged on
  // columns on screen for the detail row's colSpan: item, unit, qty, rate,
  // disc %, disc amt, amount, actions - then whichever optional ones show
  // (switched-off cells stay mounted but are not drawn)
  const lineColSpan =
    8 +
    (taxOn && colOn("tax") ? 2 : 0) +
    ["code", "batch", "expiry", "mrp", "foc", "gross"].filter(colOn).length;
  const mrpRules = {
    validate: (value) =>
      (!isNaN(value) && value >= 0) || "MRP must be zero or more",
  };
  const focRules = {
    validate: (value) =>
      (!isNaN(value) && value >= 0) || "FOC must be zero or more",
  };

  // Purchase has no split columns, so this is one Advance line plus the Online
  // card picker; the balance row reads against Net payable
  const tender = useTender({
    screenKey: "purchaseInvoice",
    control,
    setValue,
    netTotal: totalNet,
    decimalpoints,
    paymentType: watch("paymentType"),
    kind: "purchase",
    onlineValue: 4,
  });

  return (
    <div>
      <div
        className="modal fade show si-term si-term--txn"
        data-si-theme={chrome.theme}
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <form
              id="invoice-content"
              className="si-form"
              onSubmit={handleSubmit(handleFormSubmit)}
              onKeyDown={entry.onFormKeyDown}
            >
              <div className="si-grid">
                <div className="si-left">
                  {/* ============ COMMAND BAR ============ */}
                  <TermCmdBar
                    chrome={chrome}
                    title="Purchase Invoice"
                    docNo={watch("entrynumber")}
                    state={
                      mode === "edit"
                        ? { key: "edit", label: "Editing" }
                        : { key: "new", label: "New" }
                    }
                    onBack={handleClose}
                  />
                  {/* the print builder reads this input by name */}
                  <input
                    type="text"
                    className="si-offscreen"
                    tabIndex={-1}
                    aria-hidden="true"
                    {...register("entrynumber")}
                    required
                    disabled
                  />

                  {/* ============ PARTY STRIP ============ */}
                  <section className="si-strip">
                    <div className="si-strip-row">
                      <div className="si-fld" data-term-party>
                        <label>
                          Supplier Name <span className="si-req">*</span>
                        </label>
                        <div className="si-fld-ctl">
                          <Controller
                            control={control}
                            name={`supplier`}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                classNamePrefix="react-select"
                                className="si-sel"
                                options={supplierData}
                                value={supplierData?.find(
                                  (supplier) => supplier?.value === value
                                )}
                                onChange={(selectedOption) =>
                                  onChange(selectedOption.value)
                                }
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={siSelectStyles}
                                required
                              />
                            )}
                          />
                          <Link
                            to="#"
                            className="si-fld-add"
                            title="Add a new supplier"
                            onClick={() => {
                              setModalOpen(true);
                            }}
                          >
                            <Plus />
                          </Link>
                        </div>
                      </div>
                      <div className="si-fld">
                        <label>
                          Ware House <span className="si-req">*</span>
                        </label>
                        <Controller
                          name="wareHouse"
                          control={control}
                          render={({ field }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={formattedWarehouses}
                              required
                              placeholder="Select Warehouse"
                              value={getSelectedWarehouseOption(field.value)}
                              onChange={(option) =>
                                field.onChange(option.value)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>
                          Payment Type <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name={`paymentType`}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={paymentType}
                              value={paymentType?.find(
                                (paymentType) =>
                                  paymentType?.value === value
                              )}
                              onChange={(selectedOption) =>
                                onChange(selectedOption.value)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                              required
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>
                          Reference Type <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name={`referencetype`}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={referencetype}
                              value={referencetype?.find(
                                (reference) => reference?.value === value
                              )}
                              onChange={(selectedOption) =>
                                onChange(selectedOption.value)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                              required
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Date</label>
                        <Controller
                          control={control}
                          name="date"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              }
                            />
                          )}
                        />
                      </div>
                      <TermMoreToggle chrome={chrome} />
                    </div>

                    {/* kept mounted while collapsed - values still submit */}
                    <div
                      className="si-strip-row si-strip-row--more si-strip-row--auto"
                      hidden={!chrome.moreOpen}
                    >
                      <div className="si-fld">
                        <label>Reference No.</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="—"
                          {...register("refNo")}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Invoice No.</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Supplier's invoice no."
                          {...register("invoiceNo")}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Invoice Date</label>
                        <Controller
                          control={control}
                          name="invoiceDate"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()} // Set value or default to today
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              } // Update on change
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Due Date</label>
                        <Controller
                          control={control}
                          name="duedate"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()} // Set value or default to today
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              } // Update on change
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Shipment No.</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="—"
                          {...register("shipmentNo")}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Shipment Term</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="—"
                          {...register("shipmentTerms")}
                        />
                      </div>
                      <div className="si-fld si-fld--wide">
                        <label>Remarks</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Note for this invoice"
                          {...register("remarks")}
                        />
                      </div>
                      <div className="si-fld si-fld--wide">
                        <label>Product Name</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Please type product code and select"
                        />
                      </div>
                    </div>
                  </section>

                  {/* ============ LINES ============ */}
                  <section className="si-lines">
                    <TermScanBar entry={entry} fmt={fmtN} rateLabel="Cost" />

                    <TermColumns
                      chrome={chrome}
                      columns={[
                        { key: "code", label: "Barcode" },
                        { key: "batch", label: "Batch" },
                        { key: "expiry", label: "Expiry" },
                        { key: "mrp", label: "MRP" },
                        { key: "foc", label: "FOC" },
                        { key: "gross", label: "Gross" },
                        ...(taxOn ? [{ key: "tax", label: "Tax" }] : []),
                      ]}
                    >
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={handleAddRow}
                      >
                        <Plus />
                        <span>Add line</span>
                      </button>
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={() => resetmodal()}
                      >
                        <RotateCcw />
                        <span>Reset</span>
                      </button>
                    </TermColumns>

                    <div className="si-tablewrap">
                      <table
                        className="si-table"
                        style={{
                          minWidth: `${chrome.tableWidth(
                            taxOn
                              ? 1490
                              : 1324,
                            {
                              code: 110,
                              batch: 80,
                              expiry: 100,
                              mrp: 84,
                              foc: 64,
                              gross: 94,
                              tax: taxOn ? 166 : 0,
                            }
                          )}px`,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "240px" }}>
                              Item <span className="si-req">*</span>
                            </th>
                            <th
                              className={chrome.colClass("code")}
                              style={{ width: "110px" }}
                            >
                              Barcode
                            </th>
                            {/* <th className="sticky-header">HSN Code</th> */}
                            <th style={{ width: "70px" }}>Unit</th>
                            <th
                              className={chrome.colClass("batch")}
                              style={{ width: "80px" }}
                            >
                              Batch
                            </th>
                            <th
                              className={chrome.colClass("expiry")}
                              style={{ width: "100px" }}
                            >
                              Expiry
                            </th>
                            <th className="n" style={{ width: "70px" }}>
                              Qty <span className="si-req">*</span>
                            </th>
                            <th className="n" style={{ width: "90px" }}>
                              Rate <span className="si-req">*</span>
                            </th>
                            <th
                              className={`n ${chrome.colClass("mrp")}`}
                              style={{ width: "84px" }}
                            >
                              MRP
                            </th>
                            <th
                              className={`n ${chrome.colClass("foc")}`}
                              style={{ width: "64px" }}
                            >
                              FOC
                            </th>
                            <th
                              className={`n ${chrome.colClass("gross")}`}
                              style={{ width: "94px" }}
                            >
                              Gross
                            </th>
                            <th className="n" style={{ width: "84px" }}>
                              Disc %
                            </th>
                            <th className="n" style={{ width: "90px" }}>
                              Disc Amt
                            </th>
                            {taxOn && (
                              <th
                                className={`n ${chrome.colClass("tax")}`}
                                style={{ width: "76px" }}
                              >
                                VAT %
                              </th>
                            )}
                            {taxOn && (
                              <th
                                className={`n ${chrome.colClass("tax")}`}
                                style={{ width: "90px" }}
                              >
                                VAT Amt
                              </th>
                            )}
                            <th className="n" style={{ width: "104px" }}>
                              Amount
                            </th>
                            <th
                              style={{ width: "44px" }}
                              aria-label="Line actions"
                            />
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, index) => {
                            const rowProduct = entry.productByGuid(
                              watch(`items[${index}].product`)
                            );
                            const rowCode = [
                              rowProduct?.code,
                              rowProduct?.barcode,
                            ]
                              .filter(Boolean)
                              .join(" · ");
                            const open = !!openRows[field.id];
                            // keep react-hook-form's own onBlur alive while
                            // adding the barcode lookup on top of it
                            const barcodeField = register(
                              `items[${index}].code`
                            );
                            return (
                              <React.Fragment key={field.id}>
                              <tr className="si-line" data-line={index}>
                                <td data-label="Description">
                                  <div className="si-itemcell">
                                    <button
                                      type="button"
                                      className="si-exp"
                                      aria-expanded={open}
                                      aria-label="Line details"
                                      onClick={() => toggleRow(field.id)}
                                    >
                                      <ChevronRight />
                                    </button>
                                    <div className="si-item-txt">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].product`}
                                    rules={{
                                      required: "Product is required",
                                      validate: (value) => {
                                        const selectedProducts = watch(
                                          "items"
                                        )?.map((item) => item.product); // Get all selected products
                                        const isDuplicate =
                                          selectedProducts?.filter(
                                            (product) => product === value
                                          )?.length > 1;
                                        return (
                                          !isDuplicate ||
                                          "Duplicate product selected!"
                                        );
                                      },
                                    }}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-itemsel"
                                        placeholder="Item name or barcode"
                                        options={products}
                                        filterOption={entry.productFilterOption}
                                        value={products?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                          handleEachProductfetch(
                                            selectedOption,
                                            index
                                          );
                                        }}
                                        menuPortalTarget={menuPortalTarget}
                                        menuPosition="fixed"
                                        styles={siSelectStyles}
                                      />
                                    )}
                                  />
                                      {/* drawn with ::after so it stays out of
                                          the cell's innerText, which the A4
                                          print uses as the description */}
                                      {rowCode && (
                                        <div
                                          className="si-item-cd"
                                          data-cd={rowCode}
                                          aria-hidden="true"
                                        />
                                      )}
                                    </div>
                                  </div>
                                  {errors.items &&
                                    errors.items[index]?.product && (
                                      <span className="si-err">
                                        {errors.items[index].product.message}
                                      </span>
                                    )}
                                </td>
                                {/* stays mounted when hidden - the print
                                    builder reads the code from this cell */}
                                <td
                                  data-label="Item Code"
                                  className={chrome.colClass("code")}
                                >
                                  <input
                                    type="text"
                                    className="si-cellin si-cellin--text"
                                    placeholder="Scan / enter"
                                    autoComplete="off"
                                    {...barcodeField}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        // a scanner ends with Enter - look the
                                        // code up instead of submitting
                                        e.preventDefault();
                                        entry.lookupBarcode(
                                          e.target.value,
                                          index
                                        );
                                      }
                                    }}
                                    onBlur={(e) => {
                                      barcodeField.onBlur(e);
                                      entry.lookupBarcode(
                                        e.target.value,
                                        index
                                      );
                                    }}
                                  />
                                </td>
                                {/* <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register(`items[${index}].hsnCode`)}
                                    disabled
                                  />
                                </td> */}
                                <td data-label="Unit">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].unit`}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-unitsel"
                                        placeholder="—"
                                        options={unitData}
                                        value={unitData?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                        }}
                                        isDisabled={true}
                                      />
                                    )}
                                  />
                                </td>

                                {/* optional cells stay mounted (the grid keeps
                                    its column positions); their input moves to
                                    the detail row while the column is off */}
                                <td className={chrome.colClass("batch")}>
                                  {colOn("batch") && (
                                    <input
                                      type="text"
                                      className="si-cellin si-cellin--text"
                                      {...register(`items[${index}].batch`)}
                                    />
                                  )}
                                </td>
                                <td className={chrome.colClass("expiry")}>
                                  {colOn("expiry") && (
                                    <Controller
                                      control={control}
                                      name={`items[${index}].expiry`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <DatePicker
                                          className="si-celldate"
                                          placeholder={
                                            value ? dayjs(value) : dayjs()
                                          }
                                          value={value ? dayjs(value) : dayjs()}
                                          format="DD-MM-YYYY"
                                          onChange={(date) => onChange(date)}
                                        />
                                      )}
                                    />
                                  )}
                                </td>
                                <td data-label="Quantity" className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(`items[${index}].quantity`, {
                                      required: "Quantity is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "Quantity must be a positive number",
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.quantity && (
                                      <span className="si-err">
                                        {errors.items[index].quantity.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Price" className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(`items[${index}].price`, {
                                      required: "Price is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "Price must be a positive number",
                                    })}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.price && (
                                      <span className="si-err">
                                        {errors.items[index].price.message}
                                      </span>
                                    )}
                                </td>
                                <td className={`n ${chrome.colClass("mrp")}`}>
                                  {colOn("mrp") && (
                                    <>
                                      <input
                                        type="text"
                                        inputMode="decimal"
                                        className="si-cellin"
                                        {...register(
                                          `items[${index}].mrp`,
                                          mrpRules
                                        )}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.mrp && (
                                          <span className="si-err">
                                            {errors.items[index].mrp.message}
                                          </span>
                                        )}
                                    </>
                                  )}
                                </td>
                                <td className={`n ${chrome.colClass("foc")}`}>
                                  {colOn("foc") && (
                                    <>
                                      <input
                                        type="text"
                                        inputMode="decimal"
                                        className="si-cellin"
                                        {...register(
                                          `items[${index}].foc`,
                                          focRules
                                        )}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.foc && (
                                          <span className="si-err">
                                            {errors.items[index].foc.message}
                                          </span>
                                        )}
                                    </>
                                  )}
                                </td>
                                <td
                                  data-label="Gross Amount"
                                  className={`n ${chrome.colClass("gross")}`}
                                >
                                  <input
                                    type="text"
                                    className="si-cellin si-cellin--ro"
                                    tabIndex={-1}
                                    {...register(`items[${index}].gross`)}
                                    disabled
                                  />
                                </td>
                                <td data-label="Discount Percentage" className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(
                                      `items[${index}].discountPercentage`,
                                      {
                                        ...discPctEvents(setValue, index),
                                        validate: (value) =>
                                          value === "" ||
                                          value === null ||
                                          value === undefined ||
                                          (!isNaN(value) &&
                                            Number(value) >= 0 &&
                                            Number(value) <= 100) ||
                                          "Discount % must be between 0 and 100",
                                      }
                                    )}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.discountPercentage && (
                                      <span className="si-err">
                                        {
                                          errors.items[index].discountPercentage
                                            .message
                                        }
                                      </span>
                                    )}
                                </td>
                                <td data-label="Discount Amount" className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(
                                      `items[${index}].discountAmount`,
                                      discAmtRules(setValue, getValues, index)
                                    )}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.discountAmount && (
                                      <span className="si-err">
                                        {
                                          errors.items[index].discountAmount
                                            .message
                                        }
                                      </span>
                                    )}
                                </td>
                                {taxOn && (
                                  <td
                                    data-label="Tax %"
                                    className={`n ${chrome.colClass("tax")}`}
                                  >
                                    <Controller
                                      control={control}
                                      name={`items[${index}].taxPercentage`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          className="si-taxsel"
                                          options={taxData}
                                          placeholder="select"
                                          isClearable
                                          value={taxData?.find(
                                            (option) => option.guid === value
                                          )}
                                          onChange={(selectedOption) => {
                                            onChange(
                                              selectedOption
                                                ? selectedOption.guid
                                                : null
                                            );
                                          }}
                                          isDisabled={true}
                                          menuPortalTarget={menuPortalTarget}
                                          menuPosition="fixed"
                                          styles={siSelectStyles}
                                        />
                                      )}
                                    />
                                  </td>
                                )}
                                {taxOn && (
                                  <td
                                    data-label="Tax Amount"
                                    className={`n ${chrome.colClass("tax")}`}
                                  >
                                    <input
                                      type="text"
                                      className="si-cellin si-cellin--ro"
                                      tabIndex={-1}
                                      {...register(
                                        `items[${index}].taxAmount`
                                      )}
                                      disabled
                                    />
                                  </td>
                                )}
                                <td data-label="Net Amount" className="n">
                                  <input
                                    type="text"
                                    className="si-cellin si-cellin--amt"
                                    tabIndex={-1}
                                    {...register(`items[${index}].netTotal`)}
                                    disabled
                                  />
                                </td>
                                <td>
                                  <div className="si-rowacts">
                                    <Link
                                      to="#"
                                      className="si-rowbtn si-rowbtn--del confirm-text"
                                      title="Remove line (Ctrl+Del)"
                                      aria-label="Remove line"
                                      onClick={() => handleRemove(index)}
                                    >
                                      <Trash2 />
                                    </Link>
                                  </div>
                                </td>
                              </tr>

                              {open && (
                                <tr className="si-subrow">
                                  <td colSpan={lineColSpan}>
                                    <div className="si-subgrid">
                                      {!colOn("batch") && (
                                        <div className="si-subfld">
                                          <label>Batch</label>
                                          <input
                                            type="text"
                                            {...register(
                                              `items[${index}].batch`
                                            )}
                                          />
                                        </div>
                                      )}
                                      {!colOn("expiry") && (
                                        <div className="si-subfld">
                                          <label>Expiry</label>
                                          <Controller
                                            control={control}
                                            name={`items[${index}].expiry`}
                                            render={({
                                              field: { onChange, value },
                                            }) => (
                                              <DatePicker
                                                className="si-celldate"
                                                value={
                                                  value ? dayjs(value) : dayjs()
                                                }
                                                format="DD-MM-YYYY"
                                                allowClear={false}
                                                onChange={(date) =>
                                                  onChange(date)
                                                }
                                              />
                                            )}
                                          />
                                        </div>
                                      )}
                                      {!colOn("mrp") && (
                                        <div className="si-subfld">
                                          <label>MRP</label>
                                          <input
                                            type="text"
                                            inputMode="decimal"
                                            {...register(
                                              `items[${index}].mrp`,
                                              mrpRules
                                            )}
                                          />
                                          {errors.items &&
                                            errors.items[index]?.mrp && (
                                              <span className="si-err">
                                                {errors.items[index].mrp.message}
                                              </span>
                                            )}
                                        </div>
                                      )}
                                      {!colOn("foc") && (
                                        <div className="si-subfld">
                                          <label>FOC qty</label>
                                          <input
                                            type="text"
                                            inputMode="decimal"
                                            {...register(
                                              `items[${index}].foc`,
                                              focRules
                                            )}
                                          />
                                          {errors.items &&
                                            errors.items[index]?.foc && (
                                              <span className="si-err">
                                                {errors.items[index].foc.message}
                                              </span>
                                            )}
                                        </div>
                                      )}
                                    </div>
                                    <TermLineFacts
                                      product={rowProduct}
                                      sell={rowProduct?.retailRate}
                                      buy={watch(`items[${index}].price`)}
                                      fmt={fmtN}
                                    />
                                  </td>
                                </tr>
                              )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                      {lineCount === 0 && (
                        <div className="si-empty">
                          <p className="big">No lines yet</p>
                          <p>
                            Scan a barcode, or press{" "}
                            <span className="si-kbd">F3</span> and type an item
                            name.
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="si-lines-foot">
                      <span>
                        Lines <b>{lineCount}</b>
                      </span>
                      <span>
                        Qty <b>{qtyTotal}</b>
                      </span>
                      <span>
                        Gross <b>{totalGross?.toFixed(decimalpoints)}</b>
                      </span>
                      {retailTotal > 0 && (
                        <div className="si-foot-right">
                          <span>
                            Retail value <b>{fmtN(retailTotal)}</b>
                          </span>
                          {taxableTotal > 0 && (
                            <span>
                              Margin{" "}
                              <b>
                                {(
                                  ((retailTotal - taxableTotal) / retailTotal) *
                                  100
                                ).toFixed(1)}
                                %
                              </b>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </section>

                  {/* ============ STATUS BAR ============ */}
                  <TermStatusBar
                    hints={ENTRY_HINTS}
                    context={[
                      watch("wareHouse")?.name,
                      paymentLabel,
                      selectedSupplier?.name,
                    ]}
                  />
                </div>

                {/* ============ RAIL ============ */}
                <aside className="si-rail">
                  <div className="si-rail-scroll">
                    <div className="si-card">
                      <div className="si-card-h">
                        <span>Account</span>
                        <span className="r">{paymentLabel}</span>
                      </div>
                      <div className="si-party">
                        <div className="nm">
                          {selectedSupplier?.name || "No supplier selected"}
                        </div>
                        <div className="meta">
                          {selectedSupplier
                            ? [
                                selectedSupplier.code,
                                selectedSupplier.mobile,
                                selectedSupplier.gstNo,
                              ]
                                .filter((v) => v && `${v}` !== "0")
                                .join(" · ")
                            : "Pick a supplier to start"}
                        </div>
                      </div>
                    </div>

                    <div className="si-card">
                      <div className="si-card-h">Invoice total</div>
                      <div className="si-tot">
                        <div className="si-tr">
                          <span className="l">Gross</span>
                          <span className="v">
                            {totalGross?.toFixed(decimalpoints)}
                          </span>
                        </div>
                        <div className="si-tr">
                          <span className="l">Line discount</span>
                          <span className="v">
                            {lineDiscount > 0
                              ? `−${fmtN(lineDiscount)}`
                              : fmtN(0)}
                          </span>
                        </div>
                        <div className="si-tr si-tr--edit">
                          <span className="l">Bill discount</span>
                          <span className="v">
                            <input
                              type="number"
                              step="any"
                              min={0}
                              inputMode="decimal"
                              defaultValue={0}
                              {...register(`subtraction`, {
                                validate: (value) => {
                                  const discount = safeNumber(value);
                                  const totalNetAfterDiscount =
                                    totalNet - discount;
                                  if (discount < 0) {
                                    return "Discount value should not be negative.";
                                  } else if (totalNetAfterDiscount < 0) {
                                    return "Please enter a discount value that does not exceed the Net Total.";
                                  }
                                  return true;
                                },
                              })}
                            />
                          </span>
                        </div>
                        {errors.subtraction && (
                          <div className="si-tr-err">
                            {errors.subtraction.message}
                          </div>
                        )}
                        <div className="si-tr si-tr--edit">
                          <span className="l">Addition</span>
                          <span className="v">
                            <input
                              type="number"
                              step="any"
                              min={0}
                              inputMode="decimal"
                              defaultValue={0}
                              {...register(`addition`)}
                            />
                          </span>
                        </div>
                        {errors.addition && (
                          <div className="si-tr-err">
                            {errors.addition.message}
                          </div>
                        )}
                        <div className="si-rule" />
                        <div className="si-tr">
                          <span className="l">Taxable</span>
                          <span className="v">{fmtN(taxableTotal)}</span>
                        </div>
                        <div className="si-tr">
                          <span className="l">VAT</span>
                          <span className="v">
                            {totalTax?.toFixed(decimalpoints)}
                          </span>
                        </div>
                        <TermRoundOff
                          screenKey="purchaseInvoice"
                          register={register}
                          setValue={setValue}
                          control={control}
                          netTotal={totalNet}
                          decimalpoints={decimalpoints}
                          error={errors.round?.message}
                          rules={{
                            validate: (value) => {
                              const round = safeNumber(value);
                              const totalNetAfterRound = totalNet - round;
                              return (
                                totalNetAfterRound >= 0 ||
                                "Please enter a round-off value that does not exceed Net Total."
                              );
                            },
                          }}
                        />
                      </div>
                      <div className="si-net">
                        <span className="l">Net payable</span>
                        <span
                          className="v"
                          title={totalNet?.toFixed(decimalpoints)}
                        >
                          {totalNet?.toFixed(decimalpoints)}
                        </span>
                      </div>
                    </div>

                    <TermTender
                      tender={tender}
                      register={register}
                      setValue={setValue}
                      control={control}
                      Controller={Controller}
                      fmt={fmtN}
                      decimalpoints={decimalpoints}
                      paymentLabel={paymentLabel}
                      error={errors.advancePaid?.message}
                      menuPortalTarget={menuPortalTarget}
                      selectStyles={siSelectStyles}
                    />
                  </div>

                  <div className="si-actions">
                    <button
                      type="submit"
                      className="si-btn si-btn--primary"
                      data-term-action="save-print"
                      onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
                    >
                      <Printer />
                      <span>Save &amp; print</span>
                      <span className="si-kbd">F9</span>
                    </button>
                    <button className="si-btn si-btn--ghost" type="submit">
                      <Check />
                      <span>Save only</span>
                    </button>
                  </div>
                </aside>
              </div>
            </form>
          </div>
        </div>
        {/* react-select menus portal here so they inherit the .si-term tokens */}
        <div ref={setMenuHost} className="si-menu-host" />
      </div>
      {modalOpen && (
        <SupplierModal
          mode="add"
          data={{}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {}}
        />
      )}
    </div>
  );
};
export default PurchaseInvoiceModal;
